import React from 'react';
import { useLocation } from 'react-router-dom';
import WhatsAppButton from './WhatsAppButton';

const ConditionalWhatsApp: React.FC = () => {
  const location = useLocation();
  const path = location.pathname.toLowerCase();
  if (path.startsWith('/resident-home')) {
    return null;
  }
  return <WhatsAppButton />;
};

export default ConditionalWhatsApp;
